import _objectWithoutProperties from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import TextFieldMasked from "./TextFieldMasked";
import { Field } from "redux-form"; // import { Field } from 'react-final-form';

var TextField =
/*#__PURE__*/
function (_Component) {
  _inherits(TextField, _Component);

  function TextField(props) {
    var _this;

    _classCallCheck(this, TextField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextField).call(this, props));

    _this.handleOnKeyUp = function (e) {
      if (e.target.value.length === _this.props.fieldLength) {
        if (e.key !== "Tab") {
          if (_this.reachedMax && _this.props.toggleSnackbar) {
            _this.props.toggleSnackbar(true, "You have reached the maximum length of this input field", "red");
          } else {
            _this.reachedMax = true;
          }
        }
      } else {
        _this.reachedMax = false;
      }
    };

    return _this;
  }

  _createClass(TextField, [{
    key: "handleChangeRequirement",
    value: function handleChangeRequirement(value) {
      if (this.props.changeRequirement) this.props.changeRequirement(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          context = _this$props.context,
          fieldName = _this$props.fieldName,
          other = _objectWithoutProperties(_this$props, ["context", "fieldName"]);

      return React.createElement(Field, Object.assign({
        context: context,
        name: fieldName,
        component: TextFieldMasked,
        onKeyUp: this.handleOnKeyUp,
        required: this.props.required,
        validate: this.props.validation,
        fullWidth: this.props.fullWidth,
        showMargin: this.props.showMargin,
        margin: this.props.margin,
        labelShrink: true,
        onBlur: function onBlur(e) {
          if (_this2.handleChangeRequirement) _this2.handleChangeRequirement(e.target.value);
        },
        ref: this.saveRef,
        forwardRef: true
      }, other));
    }
  }]);

  return TextField;
}(Component);

export default TextField;